import { Skeleton } from './styles'

export default Skeleton
